// src/components/common/Notification.jsx
import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Badge,
  Button,
  Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNotifications } from '../../context/NotificationContext';

const NotificationPanel = ({ open, onClose }) => {
  const { notifications, markAsRead, markAllAsRead } = useNotifications();

  const handleNotificationClick = (id) => {
    markAsRead(id);
    // Additional actions can be added here
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': { 
          width: { xs: '100%', sm: 350 },
          padding: 2
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" component="div">
          Notifications
        </Typography>
        <IconButton onClick={onClose} edge="end">
          <CloseIcon />
        </IconButton>
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <Button 
          size="small" 
          onClick={markAllAsRead}
          disabled={notifications.every(n => n.read)}
        >
          Mark all as read
        </Button>
      </Box>
      
      <Divider />
      
      {notifications.length === 0 ? (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">No notifications</Typography>
        </Box>
      ) : (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {notifications.map((notification) => (
            <React.Fragment key={notification.id}>
              <ListItem 
                alignItems="flex-start" 
                onClick={() => handleNotificationClick(notification.id)}
                sx={{ 
                  bgcolor: notification.read ? 'inherit' : 'action.hover',
                  cursor: 'pointer'
                }}
              >
                <Paper 
                  elevation={notification.read ? 0 : 1} 
                  sx={{ width: '100%', p: 1 }}
                >
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="subtitle2">
                          {notification.title}
                          {!notification.read && (
                            <Badge 
                              color="primary" 
                              variant="dot" 
                              sx={{ ml: 1 }}
                            />
                          )}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {new Date(notification.timestamp).toLocaleTimeString([], {
                            hour: '2-digit', 
                            minute: '2-digit'
                          })}
                        </Typography>
                      </Box>
                    }
                    secondary={notification.message}
                  />
                </Paper>
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}
        </List>
      )}
    </Drawer>
  );
};

export default NotificationPanel;